import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, onValue } from "firebase/database";
import { auth, db } from "src/firebase";

type RecipeContextType = {
  pinnedRecipes: Record<string, boolean>;
};

const RecipeContext = createContext<RecipeContextType>({
  pinnedRecipes: {},
});

export const RecipeProvider = ({ children }: { children: React.ReactNode }) => {
  const [pinnedRecipes, setPinnedRecipes] = useState<Record<string, boolean>>(
    {}
  );

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setPinnedRecipes({});
        return;
      }

      const userRef = ref(db, `users/${user.uid}/recipes`);

      return onValue(userRef, (snapshot) => {
        setPinnedRecipes(snapshot.val() || {});
      });
    });

    return () => unsubscribe();
  }, []);

  return (
    <RecipeContext.Provider value={{ pinnedRecipes }}>
      {children}
    </RecipeContext.Provider>
  );
};

export const usePinnedRecipes = () => useContext(RecipeContext);
